/**
 * SEPA-Einzahlungsschein (EPC069-12) – QR-Inhalt für Überweisung
 * Zeilen getrennt durch \n, Felder maximal 70 Zeichen (Umlaute als UTF-8).
 */
export function buildSepaQrContent({ iban, bic, recipient, amountEur, reference, creditorId }) {
  const lines = [];
  lines.push('BCD'); // Service Tag
  lines.push('002'); // Version
  lines.push('1');   // Zeichensatz 1 = UTF-8
  lines.push('SCT'); // Identifikation SEPA Credit Transfer
  lines.push((bic || '').replace(/\s/g, '').toUpperCase().padEnd(11, ' ').slice(0, 11));
  lines.push((recipient || '').slice(0, 70));
  lines.push((iban || '').replace(/\s/g, '').toUpperCase().slice(0, 34));
  lines.push('EUR' + (amountEur != null ? Number(amountEur).toFixed(2) : '0.00'));
  lines.push(''); // purpose (optional)
  lines.push(''); // structured reference (optional)
  lines.push((reference || '').slice(0, 140));
  if (creditorId) {
    lines.push((String(creditorId).replace(/\s/g, '') || '').slice(0, 35));
  }
  return lines.join('\n');
}
